import { useState } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { isMobile } from 'react-device-detect';
import InstallDesktopIcon from '@mui/icons-material/InstallDesktop';
import InstallMobileIcon from '@mui/icons-material/InstallMobile';

import { useDeviceService } from '../../hooks';
import { DEVICE_TYPE } from '../../types/deviceType';

import Downloader from '../downloader';
import OnBoarding from '../onBoarding';

const InstallButton = () => {
	const [trigger, setTrigger] = useState(0);

	const i18n = useTranslation();

	const { getDeviceType } = useDeviceService();

	const renderSwitch = () => {
		switch (getDeviceType()) {
			case DEVICE_TYPE.DESKTOP_CHROME:
				return <Downloader trigger={trigger}></Downloader>;
			default:
				return <OnBoarding trigger={trigger}></OnBoarding>;
		}
	};

	return (
		<WrapperInstallBtn>
			<StyledButton
				id="install-button"
				onClick={() => {
					setTrigger((trigger) => trigger + 1);
				}}
			>
				<StyledSpan>{i18n.t('Install')}</StyledSpan>
				{isMobile ? (
					<InstallMobileIcon
						style={{
							fontSize: '1.2rem',
							marginLeft: '8px',
						}}
					/>
				) : (
					<InstallDesktopIcon
						style={{
							fontSize: '1.3rem',
							marginLeft: '10px',
						}}
					/>
				)}
			</StyledButton>
			{renderSwitch()}
		</WrapperInstallBtn>
	);
};

const StyledButton = styled.button`
	margin-top: 0.7rem;
	margin-right: 0.7rem;
	display: flex;
	max-width: 6.5rem;
	height: 34px;
	width: 100%;
	padding: 6px 12px;
	margin-bottom: 5px;
	font-size: 16px;
	font-weight: 400;
	line-height: 1.42857143;
	cursor: pointer;
	background-color: #e1843c;
	border: 1px solid transparent;
	height: 40px;
	color: #fff;
	:hover {
		cursor: pointer;
		filter: brightness(0.8);
	}
	:focus-visible {
		outline: solid 3px #e1843c;
	}
`;

const StyledSpan = styled.span`
	align-items: center;
`;

const WrapperInstallBtn = styled.div`
	display: flex;
	justify-content: end;
`;

export default InstallButton;
